"use client";

import Context from "@/context/Context";
import Layout from "@/components/Header/Layout";
import Signup from "@/components/User/Signup";
import HomeChatSwitcher from "@/components/Common/HomeChatSwitcher";

const SignupClient = () => (
  <Context>
    <Layout />
    <Signup />
    <HomeChatSwitcher />
  </Context>
);

export default SignupClient;
